import React from 'react'
import {css} from '@emotion/core'
import AboutValueProp from './AboutValueProp'

const aboutUsTranslations = require('../../translations/aboutUs.json')

const StaticSquiggle2 = ({className}) => (
    <svg
        className={className}
        xmlns="http://www.w3.org/2000/svg"
        width="233"
        height="312"
        viewBox="0 0 233 312"
        fill="none"
    >
        <path
            d="M-31 1.50037C8.66667 12.0733 91 51.2594 103 123.42C118 213.621 87 250.296 59 246.331C31 242.366 40 150.183 140 141.262C240 132.341 245 244.348 216 309.769"
            stroke="#5668F1"
            strokeWidth="3"
            strokeLinecap="round"
        />
    </svg>
)

const AboutSubsection1 = ({lang, themeStyles}) => {
    const localizations = aboutUsTranslations[lang]
    const verboseLangs = ['es', 'pt']
    const isVerboseLang = verboseLangs.includes(lang)
    return (
        <div
            css={css`
                width: 100%;
                background: #1e222d;
                padding: 197px 16px 100px;
                display: flex;
                flex-direction: column;
                align-items: center;
                justify-content: center;
                position: relative;
                @media (${themeStyles.breakPoints.mobile}) {
                    padding-top: 119px;
                }
            `}
        >
            <img
                src={themeStyles.about.laptop}
                alt="laptop"
                css={css`
                    max-width: 399px;
                    width: 100%;
                    position: absolute;
                    top: -135px;
                    left: 50%;
                    transform: translateX(-50%);
                    @media (${themeStyles.breakPoints.desktopMediumAndAbove}) {
                        top: -160px;
                    }
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 250px;
                        top: -95px;
                    }
                `}
            />
            <StaticSquiggle2
                css={css`
                    position: absolute;
                    top: 310px;
                    left: -31px;
                    z-index: 0;
                    pointer-events: none;
                    max-width: 262px;
                    width: 100%;
                    @media (${themeStyles.breakPoints.tabletSmall}) {
                        left: -70px;
                    }
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 123px;
                        top: 200px;
                        left: -31px;
                    }
                `}
            />
            <h2
                css={css`
                    font-size: 68px;
                    color: #fbfbfd;
                    text-align: center;
                    max-width: 1105px;
                    font-weight: 700;
                    letter-spacing: -1.36px;
                    line-height: 76px;
                    margin-bottom: 69px;
                    padding: 0 32px;
                    @media (${themeStyles.breakPoints.mobile}) {
                        max-width: 359px;
                        ${isVerboseLang
                            ? css`
                                  font-size: 38px;
                              `
                            : css`
                                  font-size: 48px;
                              `}
                        line-height: 56px;
                        letter-spacing: -0.96px;
                        margin-bottom: 40px;
                    }
                `}
            >
                {localizations.heading2}
            </h2>
            <div
                css={css`
                    max-width: 732px;
                    width: 100%;
                    display: flex;
                    flex-direction: column;
                    gap: 16px;
                    z-index: 1;
                `}
            >
                {localizations.valuePropList.map((item, index) => (
                    <AboutValueProp key={index} item={item} index={index} themeStyles={themeStyles} />
                ))}
            </div>
        </div>
    )
}

export default AboutSubsection1
